import { useUserContext } from '../components/Providers/UserContext';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';

const Welcome = () => {
  const [loading, setLoading] = useState(false);
  const { login, error } = useUserContext();
  const navigate = useNavigate();

  const onEnterClick = () => {
    setLoading(true);
    login();
  };

  useEffect(() => {
    if (error) {
      navigate('/error', { replace: true });
    }
  }, [error, navigate]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
      }}
    >
      {loading ? (
        <div style={{ textAlign: 'center' }}>
          <div>Loading...</div>
          <div style={{ marginTop: 16 }}>Setting up your session...</div>
        </div>
      ) : (
        <div style={{ textAlign: 'center' }}>
          <h1>Welcome to Tutoring Admin</h1>
          <button
            onClick={onEnterClick}
            style={{
              padding: '12px 32px',
              fontSize: 16,
              cursor: 'pointer',
              backgroundColor: '#1976d2',
              color: '#fff',
              border: 'none',
              borderRadius: 4,
              marginTop: 16,
            }}
          >
            Enter
          </button>
          {error && (
            <div style={{ marginTop: 16, color: 'red' }}>
              <div style={{ fontWeight: 'bold' }}>Unable to Sign In</div>
              <div>
                We couldn&apos;t sign you in at the moment. Please check your connection and try
                again. If the problem continues, contact Pearson Support for assistance.
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Welcome;
